import script from "./ChambreEtageView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChambreEtageView.vue?vue&type=script&setup=true&lang=js"

import "./ChambreEtageView.vue?vue&type=style&index=0&id=0285c060&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0285c060"]])

export default __exports__